import LocalStorageAdapter from './localStorageAdapter';
import ObjectAdapter from './objectAdapter';

/**
 * Used to create a supported adapter instance for the clipboard
 *
 * @class AdapterFactory
 */
export default class AdapterFactory {
    /**
     * @type {boolean}
     * @private
     */
    _hasLocalStorage = false;

    /**
     * @param {Window} window
     */
    constructor(window) {
        this._hasLocalStorage = this._testLocalStorage(window);
    }

    /**
     * @param {Window} window
     * @return {boolean}
     * @private
     */
    _testLocalStorage(window) {
        try {
            const test = 'test';
            window.localStorage.setItem(test, test);
            window.localStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    }

    /**
     * Creates an adapter instance for the clipboard. The instance will
     * change wether the browser supports local storage or not.
     *
     * @return {AdapterInterface}
     */
    create() {
        if (this._hasLocalStorage) {
            return new LocalStorageAdapter(window, 'ofcs.editor.clipboard');
        }
        return new ObjectAdapter('ofcs.editor.clipboard');
    }
}
